import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Chart_Interface } from 'src/app/Interface/Chart_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart").pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  GetAlert(id:number):Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/GetAlert?id="+id).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  AddEdit(model: Chart_Interface):Observable<Chart_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:model.id,
      title:model.title,
      haghOzviayt:model.haghOzviayt,
      positionGrid:model.positionGrid,
      parent:model.parent,
      Token: ''
    }
    return this.http.post(environment.BaseUrl + "Daro/Chart/AddEdit",body,{headers}).pipe(
        map(data=>{
          return data as Chart_Interface
        })
    )

  }

  Delete(Id: number,
    Type: number): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/Delete?id="+Id +
      "&Type=" + Type).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  UpOrder(Id: number): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/UpOrder?id="+Id).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  DownOrder(Id: number): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/DownOrder?id="+Id).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  CutOrder(CutId: number,PastId: number,Up: boolean): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/CutOrder?CutId=" + CutId
      + "&PastId=" + PastId
      + "&Up="+Up).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

  ChildOrder(CutId: number,PastId: number): Observable<Array<Chart_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Chart/ChildOrder?CutId=" + CutId
      + "&PastId=" + PastId).pipe(
      map(data=>{
        return data as Array<Chart_Interface>
      })
    )
  }

}
